<template>
  <div>
    <div v-for="rule in rules" :key="rule.id">
      <AlertRule :rule="rule" @delete="onAlertDelete" @change="onAlertChange" />
    </div>

    <div class="ui basic right aligned segment">
      <div class="ui green labeled icon button" @click="addRule">
        <i class="ui plus icon"></i>
        {{ $t('ADD', { thing: $tc('ALERT_RULE', 1) }) }}
      </div>
    </div>
  </div>
</template>

<script>
import AlertRule from './AlertRule.vue'

export default {
  name: 'AlertRuleList',
  components: {
    AlertRule
  },
  props: {
    rules: {
      type: Array,
      required: true
    }
  },

  methods: {
    addRule() {
      this.$emit('add')
    },
    onAlertChange(rule) {
      this.$emit('change', rule)
    },
    onAlertDelete(rule) {
      this.$emit('delete', rule)
    }
  }
}
</script>
